<template>
	<div>
		<!-- Router View -->
		<router-view></router-view>
	</div>
</template>

<script>
export default {
	name: "Profile",

	data() {
		return {};
	},
};
</script>

<style lang="css" scoped></style>
